import {Flex, Text} from '@chakra-ui/react';
import {FC} from 'react';
import {useCartStore} from 'store/cartStore';
import {colors} from 'theme';

interface IProps {
  borderSide?: 'top' | 'bottom';
}

export const CartPromoText: FC<IProps> = ({borderSide = 'bottom'}) => {
  const {cartItems} = useCartStore();
  const cart_text = [];
  for (let index = 0; index < cartItems.length; index++) {
    const element = cartItems[index];
    if (element?.product?.cart_text) cart_text.push(element.product.cart_text);
  }
  const styles = {[borderSide === 'top' ? 'borderTop' : 'borderBottom']: '1px solid #E6E6E6', color: colors.green};
  if (!cart_text.length) return null;

  return (
    <Flex
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      style={styles}
      py="15px"
      px={borderSide === 'top' ? '15px' : undefined}
    >
      <Text as="span" fontWeight="500" fontSize={['14px', '18px']} textAlign="center">
        {cart_text.join(', ')}
      </Text>
    </Flex>
  );
};
